export default ({ url }) => {
  const decodedUrl = decodeURIComponent(url);
  const urlObj = new URL(decodedUrl);
  const pathSegments = urlObj.pathname.split('/');
  const fileName = pathSegments[pathSegments.length - 1];

  return fileName;
};
